/**
 * LeadTasksPanel - Tasks tab panel (pending / completed) for a lead.
 * Extracted verbatim from LeadDetailPage.jsx (behavior unchanged); state/handlers passed as props.
 */
import React from 'react';
import { format, parseISO } from 'date-fns';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { Plus, FileText, Trash2 } from 'lucide-react';

export default function LeadTasksPanel({ tasksHook, canCommunicate, tasks, pendingTasks, completedTasks }) {
  return (
    <>
                <Button size="sm" onClick={() => tasksHook.setTaskDialogOpen(true)} data-testid="add-task-btn" disabled={!canCommunicate} title={!canCommunicate ? "Only the lead owner can add tasks" : "Add Task"}><Plus className="h-4 w-4 mr-1" /> Add Task</Button>
                {tasks.length === 0 ? (
                  <div className="text-center py-12">
                    <FileText className="h-12 w-12 text-slate-300 mx-auto mb-4" />
                    <p className="text-slate-500">No tasks yet. Create your first task.</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {pendingTasks.length > 0 && (
                      <div>
                        <h4 className="text-sm font-medium text-slate-500 mb-2">Pending ({pendingTasks.length})</h4>
                        {pendingTasks.map(task => (
                          <div key={task.id} className="flex items-center gap-3 p-3 border rounded-lg mb-2 hover:border-indigo-200 transition-colors" data-testid={`task-${task.id}`}>
                            <Checkbox checked={task.completed} disabled={!canCommunicate} onCheckedChange={() => canCommunicate && tasksHook.handleToggleTask(task.id, task.completed)} />
                            <div className="flex-1">
                              <div className="flex items-center gap-2">
                                <p className="text-sm font-medium">{task.description}</p>
                                {task.source === 'auto_from_note' && (
                                  <span className="text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded bg-indigo-50 text-indigo-700 border border-indigo-200" title="Auto-generated from a note by AI">
                                    Auto
                                  </span>
                                )}
                              </div>
                              {task.due_date && <p className="text-xs text-slate-500">Due: {format(parseISO(task.due_date), 'MMM d, yyyy h:mm a')}</p>}
                            </div>
                            {canCommunicate && <Button variant="ghost" size="sm" className="text-red-600" onClick={() => tasksHook.handleDeleteTask(task.id)}><Trash2 className="h-4 w-4" /></Button>}
                          </div>
                        ))}
                      </div>
                    )}
                    {completedTasks.length > 0 && (
                      <div>
                        <h4 className="text-sm font-medium text-slate-500 mb-2">Completed ({completedTasks.length})</h4>
                        {completedTasks.map(task => (
                          <div key={task.id} className="flex items-center gap-3 p-3 border rounded-lg mb-2 bg-slate-50 opacity-70">
                            <Checkbox checked={task.completed} disabled={!canCommunicate} onCheckedChange={() => canCommunicate && tasksHook.handleToggleTask(task.id, task.completed)} />
                            <div className="flex-1">
                              <p className="text-sm font-medium line-through">{task.description}</p>
                            </div>
                            {canCommunicate && <Button variant="ghost" size="sm" className="text-red-600" onClick={() => tasksHook.handleDeleteTask(task.id)}><Trash2 className="h-4 w-4" /></Button>}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
    </>
  );
}
